/**
 * Custom Label Font Scaler
 * Scales down font size to fit container width, with minimum size before ellipsis truncation
 */
(function() {
  const MIN_FONT_SIZE_PCARD = 8; // Minimum for product cards (px)
  const MIN_FONT_SIZE_PRODUCT = 10; // Minimum for product page (px)
  const SCALE_STEP = 0.5; // Decrease by 0.5px each iteration

  function scaleLabel(label) {
    if (!label || !label.textContent.trim()) return;

    const isProductPage = label.classList.contains('product-page-custom-label');
    const minFontSize = isProductPage ? MIN_FONT_SIZE_PRODUCT : MIN_FONT_SIZE_PCARD;

    // Get computed styles
    const computedStyle = window.getComputedStyle(label);
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const availableWidth = label.offsetWidth - paddingLeft - paddingRight;

    // Get starting font size from computed style
    let currentFontSize = parseFloat(computedStyle.fontSize);
    const originalFontSize = currentFontSize;

    // Create a hidden span to measure text width
    const measurer = document.createElement('span');
    measurer.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font-family: ${computedStyle.fontFamily};
      font-weight: ${computedStyle.fontWeight};
      letter-spacing: ${computedStyle.letterSpacing};
    `;
    measurer.textContent = label.textContent;
    document.body.appendChild(measurer);

    // Scale down until text fits or we hit minimum
    measurer.style.fontSize = currentFontSize + 'px';

    while (measurer.offsetWidth > availableWidth && currentFontSize > minFontSize) {
      currentFontSize -= SCALE_STEP;
      measurer.style.fontSize = currentFontSize + 'px';
    }

    // Clean up measurer
    document.body.removeChild(measurer);

    // Apply the scaled font size
    if (currentFontSize < originalFontSize) {
      label.style.fontSize = currentFontSize + 'px';
    }

    // If still overflowing at min size, enable ellipsis
    if (currentFontSize <= minFontSize) {
      label.classList.add('custom-label--truncated');
    }
  }

  function scaleAllLabels() {
    const labels = document.querySelectorAll('.pcard-custom-label, .product-page-custom-label');
    labels.forEach(scaleLabel);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scaleAllLabels);
  } else {
    scaleAllLabels();
  }

  // Re-scale on window resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // Reset font sizes before recalculating
      document.querySelectorAll('.pcard-custom-label, .product-page-custom-label').forEach(function(label) {
        label.style.fontSize = '';
        label.classList.remove('custom-label--truncated');
      });
      scaleAllLabels();
    }, 150);
  });

  // Observe for dynamically added labels (e.g., quick view, AJAX loading)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && (node.classList.contains('pcard-custom-label') || node.classList.contains('product-page-custom-label'))) {
            scaleLabel(node);
          }
          // Check children
          const childLabels = node.querySelectorAll ? node.querySelectorAll('.pcard-custom-label, .product-page-custom-label') : [];
          childLabels.forEach(scaleLabel);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
